export default __webpack_public_path__ + "static/yoga-1-8e80a67aa6157593830f2b9f4c8fcbe6.png";